<!-- 获取车位数据接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: { "parkCode":"2KNTYVWC","pageNum":"1","pageSize":"10"},
        responseCode: 	{"data":{"parkingSpaceList":[{"parkingSpaceType":0,"parkingSpaceNumber":"008",
              "parkingSpaceStatus":0, "carLicenseNumber":"粤Y12345","mapName":"mapName","enterTime":"201801010000"}],
            "total":1},"message":"业务成功","resultCode":0,"status":1},
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取车位数据接口",
          t_url: this.commonUrls.test+"getParkingSpaceInfo",
          p_url: this.commonUrls.prod+"getParkingSpaceInfo",
          precondition: "无",
          fitSystem: "部署上线MPGS停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '分页条数' },
              { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '请求页数' },
              { info1: 'carLicenseNumber', info2: '否', info3: 'String', info4: '车牌号码' },
              { info1: 'parkingSpaceNumber', info2: '否', info3: 'String', info4: '车位编号' },
              { info1: 'imageCovertFlag', info2: '否', info3: 'Boolean', info4: '是否需要图片base64信息 默认为true,如果不需要则传参数=false' }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'total', info2: '是', info3: 'Integer', info4: '总记录数' },
              { info1: 'parkingSpaceList', info2: '是', info3: 'JSONArray', info4: '车位数据列表' }
            ]
          },{
            titleName: 'parkingSpaceList',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkingSpaceType', info2: '是', info3: 'Integer', info4: '车位类型: 0-临时车' },
              { info1: 'parkingSpaceNumber', info2: '是', info3: 'String', info4: '停车位编号' },
              { info1: 'parkingSpaceStatus', info2: '是', info3: 'Integer', info4: '车位状态: 0-空闲, 1-占用' },
              { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '车牌号码' },
              { info1: 'mapName', info2: '是', info3: 'String', info4: 'mapName' },
              { info1: 'enterTime', info2: '否', info3: 'String', info4: '进场时间yyyyMMddHHmmss' },
              { info1: 'plateColor', info2: '否', info3: 'String', info4: '车牌颜色(暂无)' },
              { info1: 'enterPlateImage', info2: '否', info3: 'String', info4: '进场车牌图片(暂无), Base64字符串' },
              { info1: 'enterCarImage', info2: '否', info3: 'String', info4: '进场车身图片, Base64字符串' },
              { info1: 'enterCarImagePath', info2: '否', info3: 'String', info4: '进场车身图片相对路径' },
              { info1: 'enterPlateImagePath', info2: '否', info3: 'String', info4: '进场车牌图片相对路径' },
              { info1: 'carLogo', info2: '否', info3: 'String', info4: '车辆品牌(暂无)' },
              { info1: 'carSizeType', info2: '否', info3: 'Integer', info4: '车辆大小类型（0未知，1小车，2大车，3超大车，4中型车）(暂无)' }
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/parking/guide/getParkingSpaceInfo.vue